<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="evgSkuSpecCode"
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="400"
      cell-class-name="align-top"
      :edit-config="{
        enabled: !disabled,
        trigger: 'click',
        mode: 'cell',
      }"
      :edit-rules="validRules"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="text_cl">
            {{ $l('form_label_Productdetails') || '产品规格明细' }}
          </div>
        </slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic-square.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic-square.jpg',
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic-square.jpg"
              style="width:60px; height:60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:specName="{ row }">
        <span
          >{{ $l('sdt_label_specNo') || '规格编号' }}：{{
            row.specNo
          }}</span
        >
        <br />
        <span
          >{{ $l('sdt_label_specName') || '规格名称' }}：{{
            row.specName
          }}</span
        >
        <br />
        <span
          >{{ $l('sdt_label_goodsSize') || '规格尺寸' }}：{{
            row.v_goodsSize
          }}</span
        >
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
export default {
  mixins: [EditLoading],
  props: {
    ncNo: { type: String, default: '' },
    skuPackSize: { type: String, default: '' },
    evgSkuCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
      },
      loading: false,
      tableColumns: tableColumns(this),
      tableData: [],
      validRules: {
        specNcNo: [
          {
            required: true,
            trigger: 'blur',
            message: this.$l('rules_sdt_specNcNo') || '请输入NC编码',
          },
        ],
      },
    }
  },
  watch: {
    ncNo: {
      handler() {
        this.changeData()
      },
    },
  },
  mounted() {
    this.getData()
  },
  computed: {},
  methods: {
    getData() {
      this.loading = true
      this.$api
        .ecomEvgSkuSpecListApi({
          evgSkuCode: this.evgSkuCode,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
          if (this.disabled) {
            this.tableData.forEach((e) => {
              e.specNcNo = this.ncNo
            })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    async changeData() {
      if (this.disabled) {
        const data = this.getTableData()
        if (data && data.length > 0) {
          data.forEach((e) => {
            e.specNcNo = this.ncNo
          })
        }
      }
    },
    getTableData() {
      const { fullData } = this.$refs.table.getTableData()
      return fullData
    },
    async validate() {
      const result = await this.$refs.table.validate(true).catch(() => true)
      return !result
    },
  },
}
</script>
<style lang="scss" scoped>
.text_cl {
  color: #2b3447;
  font-size: 16px;
  font-weight: 600;
}

::v-deep {
  .vxe-cell {
    > div {
      margin-top: 7px;
    }
  }
}
</style>
